import * as yup from "yup";

export const mobileNumberValidation = yup
    .string()
    .matches(/^07\d{9}$/, {
      message: "Please enter a valid UK mobile phone number",
      excludeEmptyString: true,
    });
